import React, { useState, useRef } from 'react'
import Mensagem from '../Mensagem'
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import TermoDeUso from './TermoDeUso'
import ValidaContato from './ValidaContato'
import { Button, Overlay, Popover } from 'react-bootstrap'
import { RiCheckboxBlankCircleLine, RiCheckboxCircleLine } from "react-icons/ri";

export default function Contato(props) {
    const [msgErroAnonimato, setMsgErroAnonimato] = useState('')
    const [msgErroNome, setMsgErroNome] = useState('')
    const [msgErroTelefone, setMsgErroTelefone] = useState('')
    const [msgErroEmail, setMsgErroEmail] = useState('')

    const [showIdentificado, setShowIdentificado] = useState(false)
    const [showAnonimo, setShowAnonimo] = useState(false)
    const [confirmou, setConfirmou] = useState(false)
    const [targetAnonimatoOuIdentificado, setTargetAnonimatoOuIdentificado] = useState(null)
    const refIdentificado = useRef(null)
    
    const changeOnClick = (event, anonimato) => {
        props.setAnonimato(anonimato)
        if (anonimato === "Identificado") {
            setShowIdentificado(!showIdentificado)
            setShowAnonimo(false)
        } else {
            setShowAnonimo(!showAnonimo)
            setShowIdentificado(false)
        }
        setTargetAnonimatoOuIdentificado(event.target)
    }

    const abreFormularioLocalOcorrencia = () => {
        setMsgErroAnonimato({ tipo:'LIMPAR', texto:'' })
        setMsgErroNome({ tipo:'LIMPAR', texto:'' })
        setMsgErroTelefone({ tipo:'LIMPAR', texto:'' })
        setMsgErroEmail({ tipo:'LIMPAR', texto:'' })

        if (props.anonimato !== 'Anonimo' && props.anonimato !== 'Identificado') {
            reDirecionaMsgErro({ tipo:'problema', texto:'Uma das opções deve ser escolhida!' })
            return
        }

        const identificado = ( props.anonimato === 'Identificado')
        ValidaContato.valida(identificado,props.dadosPessoais)
        .then( contato => {
            props.setDadosPessoais(contato)
            if (identificado) {
                setShowIdentificado(false)
            } else {
                setShowAnonimo(false)
            }
            props.atuLinhaDoTempo('local')
        })
        .catch( msgErro => {
            setShowIdentificado(false)
            setShowAnonimo(false)
            reDirecionaMsgErro(msgErro)
        })
    }

    const reDirecionaMsgErro = msgErro => {
        if (msgErro.texto.includes('Uma das opções')) {
            setMsgErroAnonimato(msgErro)
        } else if (msgErro.texto.includes('ome')) {
            setMsgErroNome(msgErro)
        } else if (msgErro.texto.includes('Telefone')) {
            setMsgErroTelefone(msgErro)
        } else if (msgErro.texto.includes('E-mail')) {
            setMsgErroEmail(msgErro)
        }
    }

    const obterPlaceHolder = rotulo => {
        let placeHolder = rotulo + " (opcional)"
        if ( props.anonimato === 'Identificado') {
            placeHolder = rotulo + " (obrigatório)"
        }

        return placeHolder
    }

    const renderEmail = () => {
        return(
            <>
                <div className="form-group col-sm-10"> 
                <label>E-mail:</label>
                    <input 
                        id="idFormDenunciaEmailDenunciante"
                        name="email"
                        type="email" 
                        className="form-control" 
                        placeholder={ obterPlaceHolder("E-mail") } 
                        value={ props.dadosPessoais.email }
                        onChange={ 
                            event => props.setDadosPessoais({ 
                                ...props.dadosPessoais, 
                                email:event.target.value 
                            })
                        } 
                    />
                </div> 
                <Mensagem mensagem={ msgErroEmail } />
            </>
        )
    }

    const renderOpcoesAnonimato = () => {
        if (!confirmou) {
            return null
        }

        return (
            <div className="row ml-1 mt-2 mb-3">
                <div id="idBtnIdentificado" ref={ refIdentificado }>
                    <Button 
                        variant="Light" 
                        onClick={ event => changeOnClick(event,'Identificado') }> 
                        <div>
                            { 
                                (props.anonimato === "Identificado")? 
                                    <RiCheckboxCircleLine className="text-info font-weight-bold mr-1" />
                                : 
                                    <RiCheckboxBlankCircleLine className="font-weight-bold mr-1" />
                            } 
                            Identificado
                        </div>
                    </Button>
                    <Overlay
                        show={ showIdentificado }
                        target={ targetAnonimatoOuIdentificado }
                        placement="top"
                        container={ refIdentificado.current }
                        containerPadding={ 20 }
                    >
                        <Popover id="popover-contained">
                            <Popover.Title as="h3" className="bg-info text-white">Identificado</Popover.Title>
                            <Popover.Content>
                                <span className="form-text text-info">
                                    <strong>
                                        - Seus dados poderão ser visualizados pelo gestor que analisará o seu relato. No entanto, todo o procedimento é realizado sob sigilo pela Controladoria Geral do Município do Rio de Janeiro.
                                    </strong>
                                </span>
                            </Popover.Content>
                        </Popover>
                    </Overlay>
                </div>
                <div id="idBtnAnonimo" ref={ refIdentificado }>
                    <Button 
                        variant="Light" 
                        onClick={ event => changeOnClick(event,'Anonimo') }> 
                        <div>
                            { 
                                (props.anonimato === "Anonimo")? 
                                    <RiCheckboxCircleLine className="text-info font-weight-bold mr-1" />
                                : 
                                    <RiCheckboxBlankCircleLine className="font-weight-bold mr-1" />
                            } 
                            Anônimo
                        </div>
                    </Button>
                    <Overlay
                        show={ showAnonimo }
                        target={ targetAnonimatoOuIdentificado }
                        placement="top"
                        container={ refIdentificado.current }
                        containerPadding={ 20 }
                    >
                        <Popover id="popover-contained">
                            <Popover.Title as="h3" className="bg-warning text-white">Anônimo</Popover.Title>
                            <Popover.Content>
                                <span className="form-text text-warning">
                                    <strong>
                                        - Seu anonimato está garantido, mas você poderá fornecer um e-mail opcional para ser contactado (mesmo que fictício). No entanto, todo o procedimento é realizado sob sigilo pela Controladoria Geral do Município do Rio de Janeiro.
                                    </strong>
                                </span>
                            </Popover.Content>
                        </Popover>
                    </Overlay>
                </div>
            </div>
        )

    }

    const renderContato = ()=> {
        if ((props.anonimato !== 'Anonimo' && props.anonimato !== 'Identificado') || !confirmou) {
            return null
        }

        if (props.anonimato === 'Anonimo') {
            return(
                renderEmail()
            )
        }

        return(
            <>   
                <div className="form-group col-sm-10">
                    <label>Nome:</label>
                    <input 
                        id="idFormDenunciaNome"
                        name="nome"
                        type="text" 
                        className="form-control" 
                        placeholder={ obterPlaceHolder("Nome completo") } 
                        value={ props.dadosPessoais.nome }
                        onChange={ 
                            event => props.setDadosPessoais({ 
                                ...props.dadosPessoais, 
                                nome:event.target.value 
                            })
                        }  
                    />
                </div> 
                <Mensagem mensagem={ msgErroNome } />
                <div className="form-group col-sm-10">
                    <label>Telefone:</label> 
                    <PhoneInput
                        id="idPhoneInput"
                        name="telefone"
                        placeholder={ obterPlaceHolder("99 99999-9999 ") } 
                        defaultCountry="BR"
                        value={ props.dadosPessoais.telefone }
                        onChange={ event => props.setDadosPessoais({ 
                            ...props.dadosPessoais, 
                            telefone:event 
                        }) }  
                    />
                </div> 
                <Mensagem mensagem={ msgErroTelefone } />
                { renderEmail() }
            </>
        )
    }

    const obterBotaoAbreFormularioLocalOcorrencia = () => {
        if (!confirmou || props.anonimato === '') {
            return (
                <button 
                    type="button" 
                    className="btn btn-outline-primary mt-4 ml-3" 
                    onClick={ abreFormularioLocalOcorrencia }
                    disabled
                >
                    Próximo
                </button>
            )
        }

        return (
            <button 
                type="button" 
                className="btn btn-outline-primary mt-4 ml-3" 
                onClick={ abreFormularioLocalOcorrencia }
            >
                Próximo
            </button>
        )
    }

    if (props.formularioEmPauta === "DenunciaComplementar" || props.linhaDoTempo.emPauta !== "contato") {
        return null;
    }

    if (!confirmou) {
        return (
            <TermoDeUso confirmou={ confirmou } setConfirmou={ setConfirmou } />
        )
    }

    return (
        <fieldset className="border p-1 mt-4">
            <legend className="row w-auto">
                <h4 className="ml-4"><small>Contato:</small></h4> 
            </legend>
            <div>
                { renderContato() }
            </div>
            { renderOpcoesAnonimato() }
            <Mensagem mensagem={ msgErroAnonimato } />
            { obterBotaoAbreFormularioLocalOcorrencia() }
        </fieldset>
    );
}